import React, { useState, useEffect } from "react";
import { createUseStyles, useTheme } from "react-jss";
import { ThemeType } from "../../styles/theme";
import downArrow from "../../assets/downArrow@2x.png";
import upArrow from "../../assets/upArrow@2x.png";
import rightArrow from "../../assets/rightArrow@2x.png";
import clsx from "clsx";

interface Props {
   data: any[];
   itemComponent: any;
   selectedIdx: number;
   toggleItem: (idx: number) => void;
}

export const useListStyles = createUseStyles((theme: ThemeType) => ({
   wrap: {
      width: "100%",
   },
   list: {
      listStyle: "none",
      padding: 0,
   },
   item: {
      borderBottom: `1px solid ${theme.monoDivider}`,
   },
   banner: {
      padding: "21px 0 23px 0",
      width: `calc(100% - ${theme.gap * 2}px)`,
      margin: "0 auto",
      background: `url(${downArrow}) no-repeat`,
      backgroundSize: "20px 20px",
      backgroundPosition: "right 0px top 50%",
      "&.open": {
         background: `url(${upArrow}) no-repeat`,
         backgroundSize: "20px 20px",
         backgroundPosition: "right 0px top 50%",
      },
      "&.right": {
         background: `url(${rightArrow}) no-repeat`,
         backgroundSize: "40px 40px",
         backgroundPosition: "right 0px top 15px",
      },
      "&.bold": {
         fontWeight: theme.medium,
      },
   },
   desc: {
      display: "none",
      width: "100%",
      background: theme.monoBg,
      padding: `24px ${theme.gap}px 30px`,
      "&.open": {
         display: "block",
      },
      "&.active": {
         display: "block",
      },
      "& p": {
         marginBottom: 24,
         lineHeight: "2.6rem",
         "&:last-of-type": {
            marginBottom: 0,
         },
         "&.gray": {
            color: theme.mono50,
         },
         "& > strong": {
            fontWeight: theme.medium,
         },
         "&.blue": {
            color: theme.primaryTxt,
         },
      },
      "& > div.noticeImg": {
         display: "flex",
         justifyContent: "center",
         marginBottom: 24,
         "& > img": {
            objectFit: "contain",
            "--height": "348px",
            height: "var(--height)",
         },
      },
   },
}));

const getParameterByName = (name: string, url: string): any => {
   name = name.replace(/[[\]]/g, "\\$&");
   var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
   if (!results) return null;
   if (!results[2]) return "";

   const isNotUrlDecoded = decodeURIComponent(
      results[2].replace(/\+/g, " ")
   ).includes("%");
   if (isNotUrlDecoded) {
      const decodedURL = decodeURIComponent(url);
      const newUrl = new URL(decodedURL);
      const urlString =
         newUrl.href.split("deferred")[0] +
         "deferred=" +
         decodeURIComponent(results[2].replace(/\+/g, " "));
      return getParameterByName(name, urlString);
   } else {
      return decodeURIComponent(results[2].replace(/\+/g, " "));
   }
};

const List: React.FC<Props> = (props) => {
   const theme = useTheme<ThemeType>();
   const classes = useListStyles({ theme });
   const [_data, _setData] = useState<any[]>([]);
   const { data, itemComponent, selectedIdx, toggleItem } = props;

   // const _id = getParameterByName("id", window.location.href);
   // const id = !!_id ? parseInt(_id) : -1;

   useEffect(() => {
      const _list = data.sort((a, b) => a.order - b.order);
      _setData(_list);
   }, [data]);

   // useEffect(() => {
   //    if (id >= 0) {
   //       toggleItem(id);
   //    }
   // }, []);

   return (
      <div className={classes.wrap}>
         <ul className={classes.list}>
            {_data.map((item, i) => {
               return (
                  <li key={i} className={classes.item}>
                     <div
                        onClick={() => {
                           toggleItem(i);
                        }}
                        className={clsx(
                           classes.banner,
                           selectedIdx === i && "open"
                        )}
                     >
                        {React.createElement(itemComponent, { item })}
                     </div>
                     <div
                        className={clsx(
                           classes.desc,
                           selectedIdx === i && "open"
                        )}
                        dangerouslySetInnerHTML={{
                           __html: item.desc,
                        }}
                     ></div>
                  </li>
               );
            })}
         </ul>
      </div>
   );
};

export default List;
